import React from "react";
import { connect } from "react-redux";
import { decodeHandler, deepClone } from "utils";
import { epocToDate, firstLetterUpper } from "utils";
import { LayoutContext } from "./../../../../common/hoc/Layout/index";
import { deepCompare } from "./../../../../../utils";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { saveBackupPlansSettingStart } from "./../../../ducks/actions";
import { bindActionCreators } from "redux";
import Loader from "App/common/ui/Loader";
import { NOTIFICATIONS } from "./../../../../../consts";
import Tooltip from "App/common/ui/Tooltip";

function BackupPlanPropagate(props) {
  const [changed, setChanged] = React.useState(false);

  const { lState, lMethods } = React.useContext(LayoutContext);
  const { sPopupState, sPopupMethods } = React.useContext(SPopupContext);
  const [planSettings, setPlanSettings] = React.useState(
    deepClone(props.backupPlans.data[lState.slidingPopup.params.planID])
  );

  const sPopupRef = React.useRef();

  /*****************************Handling  popup using enter key ***************************/
  React.useEffect(() => {
    sPopupRef.current = sPopupState;

    const handleKeyDown = e => {
      if (
        e.key === "Enter" &&
        sPopupRef.current.popup.show &&
        sPopupRef.current.popup.alertName === "saveOrDiscardChanges"
      ) {
        sPopupRef.current.popup.params.execute();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.addEventListener("keydown", handleKeyDown);
    };
  }, [sPopupState]);

  function onSelectDevice(device, isAll) {
    let tempPlan = { ...planSettings };
    if (
      isAll &&
      Object.keys(props.clients).length === planSettings.devices.length
    ) {
      tempPlan.devices = [];
    } else {
      if (
        tempPlan.devices.filter(e => e.clientUUID === device.clientUUID)
          .length > 0
      ) {
        if (!isAll) {
          const index = tempPlan.devices.findIndex(
            e => e.clientUUID === device.clientUUID
          );
          tempPlan.devices.splice(index, 1);
        }
      } else {
        tempPlan.devices.push({
          clientName: device.name,
          clientUUID: device.clientUUID
        });
      }
    }
    tempPlan = checkNonEnabledDevicesQuota(deepClone(tempPlan));
    setPlanSettings(tempPlan);
  }

  function checkNonEnabledDevicesQuota(tempPlan) {
    let newDevices = [];
    tempPlan.devices.forEach(dev => {
      if (!JSON.stringify(props.cacheSettings).includes(dev.clientUUID)) {
        newDevices.push(dev.clientUUID);
      }
    });
    let notConfiguredDevices = 0;
    newDevices.forEach(dev => {
      if (!props.clients[dev].isConfigured) {
        notConfiguredDevices++;
      }
    });
    if (notConfiguredDevices === 0) {
      tempPlan.maxClientsExceeded = false;
    } else if (
      props.computerLimit <
        notConfiguredDevices +
          Object.keys(props.clients).filter(
            val => props.clients[val].isConfigured
          ).length &&
      props.planType !== "Paid" &&
      props.ecommerceFlag !== "S"
    ) {
      tempPlan.maxClientsExceeded = true;
    } else {
      tempPlan.maxClientsExceeded = false;
    }
    return tempPlan;
  }

  function selectAllDevices() {
    Object.keys(props.clients).map((client, i) => {
      onSelectDevice(props.clients[client], true);
    });
  }

  function propagate() {
    let settings = {};
    settings.devices = planSettings.devices;
    settings.planId = planSettings.planId;
    appendLogs(settings, planSettings, props.cacheSettings);
    props.saveBackupPlansSettingStart(settings);
  }

  function appendLogs(settings, plan, cache) {
    if (plan.devices.length === 0 && cache.devices.length === 0) {
      return;
    } else {
      let pnsData = [];
      let log = {
        mode: "backupPlan",
        params: {
          planName: plan.planName,
          action: "editSettings",
          devices: []
        }
      };
      for (let i = 0; i < plan.devices.length; i++) {
        if (
          !JSON.stringify(cache.devices).includes(plan.devices[i].clientUUID)
        ) {
          log.params.devices.push({
            clientUUID: plan.devices[i].clientUUID,
            type: "added"
          });
          pnsData.push(plan.devices[i].clientUUID);
        }
      }
      for (let i = 0; i < cache.devices.length; i++) {
        if (
          !JSON.stringify(plan.devices).includes(cache.devices[i].clientUUID)
        ) {
          log.params.devices.push({
            clientUUID: cache.devices[i].clientUUID,
            type: "removed"
          });
          pnsData.push(cache.devices[i].clientUUID);
        }
      }
      settings.log = JSON.stringify(log);
      settings.pnsData = pnsData;
    }
  }

  function cancel() {
    if (changed) {
      sPopupMethods.openPopup("saveOrDiscardChanges", {
        disable: planSettings.maxClientsExceeded,
        execute: () => {
          sPopupMethods.closePopup();
          propagate();
        },
        cancel: true,
        secondExecute: () => {
          lMethods.closeSlidingPopup();
        }
      });
    } else {
      lMethods.closeSlidingPopup();
    }
  }

  React.useEffect(() => {
    const tempPlan = deepClone(planSettings);
    let maxClientsExceeded = tempPlan.maxClientsExceeded;
    delete tempPlan.maxClientsExceeded;
    if (!deepCompare(tempPlan, props.cacheSettings)) {
      setChanged(true);
      sPopupMethods.disableClose(false, {
        display: discardTo =>
          sPopupMethods.openPopup("saveOrDiscardChanges", {
            disable: maxClientsExceeded,
            execute: () => {
              sPopupMethods.closePopup();
              propagate();
            },
            cancel: true,
            secondExecute: () => {
              lMethods.closeSlidingPopup();
            }
          })
      });
    } else {
      setChanged(false);
      if (!sPopupState.disableClose.close) {
        sPopupMethods.disableClose(true, {});
      }
    }
    if (planSettings.maxClientsExceeded) {
      sPopupMethods.showNotify({
        msg: NOTIFICATIONS.enableMachine.computerLimit,
        status: "warning",
        upgrade: true
      });
    } else {
      sPopupMethods.closeNotify();
    }
  }, [planSettings]);

  React.useEffect(() => {
    if (
      !props.settings.loading &&
      props.settings.updated &&
      !props.cacheSettings
    ) {
      lMethods.closeSlidingPopup();
    }
  }, [props.settings, props.cacheSettings]);

  return (
    <React.Fragment>
      {props.settings.loading ? (
        <Loader />
      ) : (
        <div className="devices_blk">
          <div className="slider_content is_relative">
            <div className="plan_cont_blk">
              <div className="tabular_data_wrap">
                <div
                  className={`table_inner_header ${
                    planSettings.devices.length > 0 &&
                    Object.keys(props.clients).length !==
                      planSettings.devices.length
                      ? "semiactive"
                      : ""
                  }`}
                >
                  <ul className="table_container">
                    <li className="table_header">
                      <div className="col">
                        <div className="check_wrap">
                          <div className="check big">
                            {planSettings.devices.length > 0 && (
                              <input
                                onClick={selectAllDevices}
                                type="checkbox"
                                className="input_checkbox"
                                id="checkall_udevice"
                                checked
                              />
                            )}
                            {planSettings.devices.length === 0 && (
                              <input
                                onClick={selectAllDevices}
                                type="checkbox"
                                className="input_checkbox"
                                id="checkall_udevice"
                              />
                            )}
                            <label htmlFor="checkall_udevice"></label>
                          </div>
                        </div>
                      </div>
                      <div className="col col1">
                        <div className="">
                          {/* <span className="icon_sort file_sort_empty"></span> */}
                          <span className="header_title">Name</span>
                        </div>
                      </div>
                      <div className="col col2">
                        <div className="">
                          {/* <span className="icon_sort file_sort_empty"></span> */}
                          <span className="header_title">Backup Status </span>
                        </div>
                      </div>
                      <div className="col col3">
                        <div className="">
                          {/* <span className="icon_sort file_sort_empty"></span> */}
                          <span className="header_title">Last Backup Date</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="table_content_body ">
                  <ul className="table_container">
                    {Object.keys(props.clients).map((client, i) => {
                      return (
                        <li
                          className={[
                            "table_data_row list_folder",
                            planSettings.devices.filter(
                              val =>
                                val.clientUUID ===
                                props.clients[client].clientUUID
                            ).length > 0
                              ? "active"
                              : ""
                          ].join(" ")}
                          key={i}
                        >
                          <div
                            className="inner_data_row"
                            onClick={() =>
                              onSelectDevice(props.clients[client], false)
                            }
                          >
                            <div className="col">
                              <div className="check_wrap">
                                {planSettings.devices.length > 0 &&
                                  planSettings.devices.filter(
                                    val =>
                                      val.clientUUID ===
                                      props.clients[client].clientUUID
                                  ).length > 0 && (
                                    <div className="check big">
                                      <input
                                        type="checkbox"
                                        className="input_checkbox"
                                        id={"udevice_" + i}
                                        checked
                                      />
                                      <label htmlFor={"udevice_" + i}></label>
                                    </div>
                                  )}
                                {(planSettings.devices.length === 0 ||
                                  planSettings.devices.filter(
                                    val =>
                                      val.clientUUID ===
                                      props.clients[client].clientUUID
                                  ).length === 0) && (
                                  <div className="check big">
                                    <input
                                      type="checkbox"
                                      className="input_checkbox"
                                      id={"udevice_" + i}
                                    />
                                    <label htmlFor={"udevice_" + i}></label>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col col1">
                              <div
                                className={[
                                  "pc_name_blk",
                                  props.clients[client].machineStatus
                                ].join(" ")}
                              >
                                <i className="pc-icon"></i>

                                {/* checking if lenght of machine name is more than 30,
                                than only showing tooltip and doing substring operation */}
                                {decodeHandler(props.clients[client].name)
                                  .length > 30 ? (
                                  <Tooltip
                                    title={decodeHandler(
                                      props.clients[client].name
                                    )}
                                    placement="top"
                                  >
                                    <span className="">
                                      {/* {props.clients[client].name} */}

                                      {decodeHandler(props.clients[client].name)
                                        .toString()
                                        .substring(
                                          0,
                                          decodeHandler(
                                            props.clients[client].name
                                          ).length - 25
                                        ) + "..."}
                                    </span>
                                  </Tooltip>
                                ) : (
                                  <span className="">
                                    {decodeHandler(props.clients[client].name)}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col col2">
                              <span
                                className={[
                                  "bkp_status ",
                                  props.enums.BackupScheduleStatus.props[
                                    props.clients[client].status.value
                                  ].key === "IN_PROGRESS"
                                    ? "progress"
                                    : props.enums.BackupScheduleStatus.props[
                                        props.clients[client].status.value
                                      ].key === "PAUSED"
                                    ? "paused"
                                    : props.clients[client].lastBackupTime === 0
                                    ? "new"
                                    : props.enums.BackupScheduleStatus.props[
                                        props.clients[client].status.value
                                      ].key.toLowerCase()
                                ].join(" ")}
                              >
                                {props.enums.BackupScheduleStatus.props[
                                  props.clients[client].status.value
                                ].key === "IN_PROGRESS"
                                  ? "In Progress"
                                  : props.clients[client].lastBackupTime === 0
                                  ? "New"
                                  : firstLetterUpper(
                                      props.enums.BackupScheduleStatus.props[
                                        props.clients[client].status.value
                                      ].key
                                    )}
                              </span>
                            </div>
                            <div className="col col3">
                              {props.clients[client].lastBackupTime === 0
                                ? "Never"
                                : epocToDate(
                                    props.clients[client].lastBackupTime,
                                    "MMM d yyyy, hh:mm:ss"
                                  )}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="slider_content_footer">
              <div className="slider_summary_btns">
                <div className="slider_summary_btns__inner">
                  <div className="backup_image_btns just_flex">
                    <div
                      className={[
                        "slider_btn btn_primary",
                        changed && !planSettings.maxClientsExceeded
                          ? ""
                          : "btn_disable"
                      ].join(" ")}
                      onClick={() => {
                        if (changed && !planSettings.maxClientsExceeded)
                          propagate();
                      }}
                    >
                      Propagate
                    </div>
                    <div className="slider_btn btn_cancel" onClick={cancel}>
                      Cancel
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    cacheSettings: state.backupPlan.cachePlanSettings,
    clients: state.dashboard.clients.list,
    enums: state.common.enums,
    backupPlans: state.backupPlan.backupPlans,
    settings: state.backupPlan.settings,
    computerLimit: state.account.plan && state.account.plan.computerLimit,
    ecommerceFlag: state.account.ecommerceFlag,
    planType: state.account.plan && state.account.plan.planType
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveBackupPlansSettingStart
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BackupPlanPropagate);
